import React, { Component, Suspense } from "react";
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import Pagination from "react-js-pagination";
import { apiCalling, apiUrlRelianceFunction } from "../apiService";
import csv from "../image/icons/csv.png";
const folderName = window.sessionStorage.getItem("homeName");
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));

export default class videoaudioReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentData: [],
      toDate: new Date(),
      fromDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      totalCount: 0,
      activePage: 1,
      fuctionName: "VideoAudioPayment Report",
      csvDetails: [],
      showMessage: "Waiting for data... ",
      offset: "0",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.changeHandler = this.changeHandler.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.videoAudioReport("0");
  }

  handleChange = (date) => {
    this.setState({
      fromDate: date,
    });
  };
  handleChangeTo = (date) => {
    this.setState({
      toDate: date,
    });
  };

  changeHandler = (event) => {
    const { value, name } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handlePageChange(pageNumber) {
    window.scrollTo(0, 0);
    // var startDate = $("#fromDate").val();
    // var toDate = $("#toDate").val();
    // var newDate = moment(startDate, "DD-MM-YYYY").format("MM-DD-YYYY");
    // var SearchDate = new Date(newDate);
    // var milliStartDate = SearchDate.getTime();

    // if (newDate === "Invalid date") {
    //   SearchDate = "";
    //   milliStartDate = "";
    // }
    // var endDate = moment(toDate, "DD-MM-YYYY").format("MM-DD-YYYY");
    // var SearchEndDate = new Date(endDate);
    // var milliEndDate = SearchEndDate.getTime() + 86400000;
    // if (endDate === "Invalid date") {
    //   SearchEndDate = "";
    //   milliEndDate = "";
    // }
    this.setState({ activePage: pageNumber });
    var offset;
    var max;
    if (pageNumber === "1") {
      offset = "0";
      max = "10";
      this.setState({
        activePage: pageNumber,
        isLoading: "0",
        offset: offset,
      });
    } else {
      offset = parseInt(pageNumber - 1) * 10;
      max = "10";
      this.setState({
        activePage: pageNumber,
        isLoading: "0",
        offset: offset.toString(),
      });
    }
    this.videoAudioReport(offset.toString());
    // const apiJson = {
    //   method: "POST",
    //   body: JSON.stringify({
    //     functionName: "paymentReport",
    //     subFunctionName: "videoAudioPayment",
    //     userId: window.sessionStorage.getItem("userId"), //"19238",
    //     role: window.sessionStorage.getItem("role"),
    //     max: max,
    //     offset: JSON.stringify(offset),
    //     cmbCategory1:
    //       $("#videoAudioSelect").val() === "0"
    //         ? ""
    //         : $("#videoAudioSelect").val(),
    //     searchKeyWord: $("#txtVideoAudio").val(),
    //     appointmentStatus:
    //       $("#appointmentStatusType").val() === "0"
    //         ? ""
    //         : $("#appointmentStatusType").val(),
    //     appointmentType:
    //       $("#appointmentType1").val() === "0"
    //         ? ""
    //         : $("#appointmentType1").val(),
    //     exportFromDate: milliStartDate,
    //     exportToDate: milliEndDate,
    //     fromDate: milliStartDate,
    //     toDate: milliEndDate,
    //   }),
    // };
    // console.log(apiJson.body);
    // $(".loader").show();
    // let apiFunction = folderName !== null ? apiCalling : apiUrlRelianceFunction;
    // apiFunction(apiJson).then((data) => {
    //   if (data.success === "1") {
    //     this.setState({
    //       paymentData: data.result.paymentData,
    //       totalCount: data.result.count,
    //     });
    //     $(".loader").hide();
    //   }
    // });
  }

  videoAudioReport(offset) {
    // var today = new Date();
    // var firstDayOfPreviousMonth = new Date(
    //   today.getFullYear(),
    //   today.getMonth() - 1,
    //   1
    // );
    // // var startDate = moment().subtract(30, 'days').toDate(); // convert to Date object
    // var toDate = moment().toDate(); // convert to Date object
    // var startDateMilliseconde = firstDayOfPreviousMonth.getTime();
    // var toDateMilliseconde = toDate.getTime();
    // this.setState({
    //   fromDate: startDateMilliseconde,
    //   toDate: toDateMilliseconde,
    // });
    $(".loader").show();
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "paymentReport",
        subFunctionName: "videoAudioPayment",
        userId: window.sessionStorage.getItem("userId"), // "19238",
        role: window.sessionStorage.getItem("role"),
        max: "10",
        offset: offset,
        exportFromDate: new Date(this.state.fromDate).getTime(),
        exportToDate: new Date(this.state.toDate).getTime(),
        fromDate: new Date(this.state.fromDate).getTime(),
        toDate: new Date(this.state.toDate).getTime(),
        cmbCategory1:
          $("#videoAudioSelect").val() === "0"
            ? ""
            : $("#videoAudioSelect").val(),
        searchKeyWord: $("#txtVideoAudio").val(),
        appointmentStatus:
          $("#appointmentStatusType").val() === "0"
            ? ""
            : $("#appointmentStatusType").val(),
        appointmentType:
          $("#appointmentType1").val() === "0"
            ? ""
            : $("#appointmentType1").val(),
      }),
    };
    let abcc = folderName != null ? "a1" : "apiUrlRelianceFunction";
    // alert(abcc)
    let apiFunction = folderName !== null ? apiCalling : apiUrlRelianceFunction;
    //console.log(apiFunction)
    apiFunction(apiJson).then((data) => {
      $(".loader").hide();
      //alert(data.success)
      if (data.success === "1") {
        this.setState({
          paymentData: data.result.paymentData,
          csvDetails: data.result.paymentExportData,
          totalCount: data.result.count,
        });
      }
      if (data.success === "0") {
        $(".loader").hide();
        this.setState({
          paymentData: [],
          csvDetails: [],
          showMessage: data.errorMessage,
        });
      }
    });
  }

  changeText = () => {
    if ($("#videoAudioSelect").val() !== "0") {
      document.getElementById("txtVideoAudio").disabled = false;
      $("input[name=txtVideoAudio]").focus();
    } else {
      document.getElementById("txtVideoAudio").disabled = true;
    }
    document.getElementById("txtVideoAudio").value = "";
  };

  searchHandler() {
    // var startDate = $("#fromDate").val();
    // var toDate = $("#toDate").val();
    // var newDate = moment(startDate, "DD-MM-YYYY").format("MM-DD-YYYY");
    // var SearchDate = new Date(newDate);
    // var milliStartDate = SearchDate.getTime();

    // if (newDate === "Invalid date") {
    //   SearchDate = "";
    //   milliStartDate = "";
    // }
    // var endDate = moment(toDate, "DD-MM-YYYY").format("MM-DD-YYYY");
    // var SearchEndDate = new Date(endDate);
    // var milliEndDate = SearchEndDate.getTime() + 86400000;
    // if (endDate === "Invalid date") {
    //   SearchEndDate = "";
    //   milliEndDate = "";
    // }

    if (
      $("#videoAudioSelect").val() !== "0" &&
      $("#txtVideoAudio").val() === ""
    ) {
      var t = document.getElementById("videoAudioSelect");
      var selectedText = t.options[t.selectedIndex].text;
      alert(selectedText + " Required");
      $("#txtVideoAudio").focus();
      return false;
    }
    if (this.state.fromDate > this.state.toDate) {
      alert("To date should be greater than or equal to from date");
      return false;
    } else {
      this.videoAudioReport("0");
      //   const searchData = {
      //     method: "POST",
      //     body: JSON.stringify({
      //       functionName: "paymentReport",
      //       subFunctionName: "videoAudioPayment",
      //       userId: window.sessionStorage.getItem("userId"), //"19238",
      //       role: window.sessionStorage.getItem("role"),
      //       max: "10",
      //       offset: "0",
      //       cmbCategory1:
      //         $("#videoAudioSelect").val() === "0"
      //           ? ""
      //           : $("#videoAudioSelect").val(),
      //       searchKeyWord: $("#txtVideoAudio").val(),
      //       appointmentStatus:
      //         $("#appointmentStatusType").val() === "0"
      //           ? ""
      //           : $("#appointmentStatusType").val(),
      //       appointmentType:
      //         $("#appointmentType1").val() === "0"
      //           ? ""
      //           : $("#appointmentType1").val(),
      //       exportFromDate: milliStartDate,
      //       exportToDate: milliEndDate,
      //       fromDate: milliStartDate,
      //       toDate: milliEndDate,
      //     }),
      //   };
      //   $(".loader").show();
      //   console.log(searchData.body);
      //   let apiFunction =
      //     folderName !== null ? apiCalling : apiUrlRelianceFunction;
      //   apiFunction(searchData).then((data) => {
      //     if (data.success === "1") {
      //       $(".loader").hide();
      //       this.setState({
      //         paymentData: data.result.paymentData,
      //         csvDetails: data.result.paymentExportData,
      //         totalCount: data.result.count,
      //         activePage: 1,
      //       });
      //     }
      //     if (data.success === "0") {
      //       $(".loader").hide();
      //       this.setState({
      //         paymentData: [],
      //         showMessage: data.errorMessage,
      //         csvDetails: [],
      //       });
      //     }
      //   });
    }
  }

  csvFileDownload() {
    const csvRow = [];
    var columnDetails = [
      [
        "Patient Name",
        "Patient Email Id",
        "Patient Mobile Number",
        "Hospital Name",
        "Doctor Name",
        "Chat Requested Date",
        "Transaction Id",
        "Appointment Type",
        "Appointment Time",
        "Appointment Status",
        "Coupon Amount",
        "Doctor Charge",
        "Amount Received",
      ],
    ];
    var results = this.state.csvDetails;

    for (var item = 0; item < results.length; item++) {
      columnDetails.push([
        results[item].memName,
        results[item].emailId,
        results[item].mobNo,
        results[item].hospitalName,
        results[item].docName,
        moment(results[item].requestedDate).format("DD-MMM-YYYY"),
        results[item].transactionId,
        results[item].type,
        moment(results[item].requestedDate).format("hh:mm A"),
        results[item].statusName,
        results[item].promoAmt,
        results[item].actualAmount,
        results[item].amount,
      ]);
    }

    for (var i = 0; i < columnDetails.length; ++i) {
      csvRow.push(columnDetails[i].join(","));
    }

    var csvString = csvRow.join("%0A");

    var dataType = document.createElement("a");

    dataType.href = "data:attachment/csv," + csvString;
    dataType.target = "_Blank";
    dataType.download = this.state.fuctionName + ".csv";
    document.body.appendChild(dataType);
    dataType.click();
  }

  render() {
    return (
      <div class="purpleWrap">
        <Suspense fallback={<div>Waiting...</div>}>
          <section>
            {folderName !== null && <Header />}
            <div className="loader"></div>
            <div class="col-md-11 m-auto">
              <div class="main-wrapper1">
                <div class="col-md-12 p-0">
                  <ul class="breadcrumb">
                    <li>
                      <a
                        href={
                          "/dashboard/reportDashboard/" +
                          this.props.match.params.groupHospitalId
                        }
                      >
                        Reports
                      </a>
                      <i class="fa fa-chevron-right"></i>
                    </li>
                    <li>Video /Audio Chat Payment Report</li>
                  </ul>
                </div>
                <div class="form-head"> Video /Audio Chat Payment Report </div>
                <div class="custom-search row">
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <select
                      class="input-design"
                      id="videoAudioSelect"
                      name="videoAudioSelect"
                      onChange={() => this.changeText()}
                    >
                      <option value="0">- - Select - -</option>
                      <option value="Patient Name">Patient Name</option>
                      <option value="Patient Mobile Number">
                        Patient Mobile No.
                      </option>
                      <option value="Patient EmailId">Patient Email</option>
                      <option value="Doctor Name"> Doctor Name</option>
                      <option value="Hospital Name">Hospital Name</option>
                      <option value="Transaction Id"> Transaction ID</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <input
                      type="text"
                      class="input-design"
                      id="txtVideoAudio"
                      name="txtVideoAudio"
                      disabled
                    />
                  </div>
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <select
                      class="input-design"
                      id="appointmentType1"
                      name="appointmentType1"
                    >
                      <option value="0">Appointment Type </option>
                      <option value="Video Chat">Video Chat</option>
                      <option value="Audio Chat">Audio Chat</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <select
                      class="input-design"
                      id="appointmentStatusType"
                      name="appointmentStatusType"
                    >
                      <option value="0">Appointment Status</option>
                      <option value="Open">Open</option>
                      <option value="Confirmed">Confirmed</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Cancel">Cancel</option>
                      <option value="Completed">Completed</option>
                      <option value="Call Completed">Call Completed</option>
                    </select>
                  </div>
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <DatePicker
                      placeholderText="From Date"
                      id="fromDate"
                      name="fromDate"
                      selected={this.state.fromDate}
                      onChange={this.handleChange}
                      dateFormat="dd/MM/yyyy"
                      calendarClassName="react-date-picker"
                    />
                  </div>
                  <div class="col-md-4 col-6 custom-search-sub custom-search-subWidth">
                    <DatePicker
                      placeholderText="To Date"
                      id="toDate"
                      name="toDate"
                      selected={this.state.toDate}
                      onChange={this.handleChangeTo}
                      dateFormat="dd/MM/yyyy"
                      calendarClassName="react-date-picker"
                    />
                  </div>
                  <div class="col-md-1 col-10 mb-3 custom-search-sub custom-search-subWidth">
                    <input
                      type="submit"
                      value="Search"
                      class="formButton m-0 formButtonsearch-width"
                      onClick={() => this.searchHandler()}
                    />
                  </div>
                  <div className="mb-3 custom-search-sub p-0 ml-2">
                    <a
                      onClick={() => this.csvFileDownload()}
                      className="cursor-pointer"
                    >
                      <img
                        src={csv}
                        alt="csv"
                        width="25"
                        title="Export CSV"
                        className="mt-1"
                      />
                    </a>
                  </div>
                </div>
                {this.state.paymentData.length > 0 ? (
                  <div class="table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Patient Name</th>
                          <th>Patient Email Id</th>
                          <th>Patient Mobile Number</th>
                          <th>Hospital Name</th>
                          <th>Doctor Name</th>
                          <th>Video Chat Requested Date</th>
                          <th>Transaction Id</th>
                          <th>Appointment Type</th>
                          <th> Appointment Time</th>
                          <th>Appointment Status </th>
                          <th>Coupon Amount</th>
                          <th>Doctor Charge</th>
                          <th>Amount Received</th>
                          <th>Chat Details</th>
                        </tr>
                      </thead>
                      <tbody style={{ fontSize: "12px" }}>
                        {this.state.paymentData.map((data) => {
                          let requestedDate = moment(data.requestedDate).format(
                            "DD-MMM-YYYY"
                          );
                          let appointmentTime = moment(
                            data.requestedDate
                          ).format("hh:mm A");
                          return (
                            <tr className="border-bottom">
                              <td>{data.memName}</td>
                              <td>{data.emailId}</td>
                              <td>{data.mobNo}</td>
                              <td>{data.hospitalName}</td>
                              <td>Dr.{data.docName}</td>
                              <td>
                                {requestedDate === "01-Jan-1970"
                                  ? ""
                                  : requestedDate}
                              </td>
                              <td>{data.transactionId}</td>
                              <td>{data.type}</td>
                              <td>{appointmentTime}</td>
                              <td>{data.statusName}</td>
                              <td>₹ {data.promoAmt}</td>
                              <td>₹ {data.actualAmount}</td>
                              <td>₹ {data.amount}</td>
                              <td>
                                {data.chatDetails.map((i) => {
                                  let startTime = moment(
                                    parseInt(i.chatStartTime)
                                  )
                                    .add(moment.duration(1000))
                                    .format("HH:mm:ss");

                                  let endTime = moment(
                                    parseInt(i.chatEndTime)
                                  ).format("HH:mm:ss");

                                  let ms = moment(endTime, "HH:mm:ss").diff(
                                    moment(startTime, "HH:mm:ss")
                                  );

                                  let dur = moment.utc(ms).format("HH:mm:ss");
                                  return (
                                    <p className="vid-aud-rprs-p">
                                      <span>Duration : {dur}</span>
                                    </p>
                                  );
                                })}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                    {this.state.totalCount > 5 ? (
                      <div className="paginationSection orderm-paginationSection">
                        <Pagination
                          activePage={this.state.activePage}
                          itemsCountPerPage={10}
                          totalItemsCount={this.state.totalCount}
                          pageRangeDisplayed={10}
                          onChange={this.handlePageChange}
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <p className="error-msg text-center mb-0">
                    {" "}
                    {this.state.showMessage}{" "}
                  </p>
                )}
              </div>
            </div>
            {folderName !== null && <Footer />}
          </section>
        </Suspense>
      </div>
    );
  }
}
